// Packages
import { useState, useEffect } from 'react';

// Components
import StockList from 'modules/Stock/components/List';
import StockCreateScreen from '../Create';
import AddIcon from 'components/BTDUI/icons/BTDFAB';
import StockLayout from 'modules/Stock/layouts';
import BTDPagination from 'components/BTDUI/BTDPagination';
import BTDTextField from 'components/BTDUI/fields/BTDTextField';
import ClearIcon from 'components/BTDUI/icons/ClearIcon';
import BTDSelectField from 'components/BTDUI/fields/BTDSelectField';
import BTDMenu from 'components/BTDUI/BTDMenu';
import EllipsisIcon from 'components/BTDUI/icons/EllipsisIcon';
import Search2Icon from 'components/BTDUI/icons/Search2Icon';
import LetterIcon from 'components/BTDUI/icons/LetterIcon';
import BTDProgress from 'components/BTDUI/BTDProgress';

// Other
import useApi from 'hooks/useApi';
import './styles.css';

const StockScreen = () => {

    const [page, setPage] = useState(1);

    const { data: items, isLoading, meta, onChange } = useApi('/stock?page=' + page + '&per_page=100&with=supplier');
    const { data: searchResults, post: submit, isLoading: searchLoading } = useApi('/stock/search?with=supplier&per_page=100', false);
    const { data: searchByLetterResults, post: searchByLetter, isLoading: searchbyLetterLoading } = useApi('/stock/search-by-letter?with=supplier&per_page=100', false);
    const { data: pdfUrl, get: generatePDF } = useApi('/stock/generate-pdf', false);
    const { data: csvUrl, get: generateCSV } = useApi('/stock/generate-csv', false);

    const queryParams = new URLSearchParams(window.location.search);
    const urlQuery = queryParams.get('query');
    
    const [formActive, setFormActive] = useState(false);
    const [showPagination, setShowPagination] = useState(true);
    const [query, setQuery] = useState('');
    const [letter, setLetter] = useState('');
    const [stock, setStock] = useState([]);

    useEffect(() => {

        if( items.length !== 0 ) {

            setStock(items);
            setShowPagination(true);
            setQuery('');
            setLetter('');
        }

        if(urlQuery) {

            setQuery(urlQuery);
            submit({query: urlQuery});
        }

    }, [items, urlQuery])

    useEffect(() => {

        setStock(searchResults);
        if(query !== '') {

            setShowPagination(false);
        }
        else {

            setShowPagination(true);
        }
        setLetter('');

    // eslint-disable-next-line
    }, [searchResults])

    useEffect(() => {

        setStock(searchByLetterResults);
        setQuery('');
        if( letter !== '' && letter !== null ) {

            setShowPagination(false);
        }
        else {

            setShowPagination(true);
        }
    // eslint-disable-next-line
    }, [searchByLetterResults])


    useEffect(() => {

        if( pdfUrl && pdfUrl.length !== 0) {

            document.getElementById('downloadLink').href = pdfUrl.url;

            document.getElementById('downloadLink').click();
        }

    }, [pdfUrl])

    useEffect(() => {

        if( csvUrl && csvUrl.length !== 0) {

            document.getElementById('downloadLink').href = csvUrl.url;

            document.getElementById('downloadLink').click();
        }

    }, [csvUrl])

    return(
        <StockLayout title='Stock'>

            <div className='StockListScreen__filters'>

                <form className='SearchBar' style={{gridArea: 'search'}} onSubmit={(e) => {
                    e.preventDefault();
                    submit({query: query}, false);
                }}>

                    <BTDTextField
                        label='Search for stock'
                        onChange={(value) => {setQuery(value)}}
                        startIcon={query ? 
                            <ClearIcon 
                                height='28px' 
                                width='28px'
                                onClick={ () => {
                                    setQuery('');
                                    submit({query: null}, false);
                                }} 
                                style={{cursor: 'pointer'}}
                            /> 
                            : 
                            <Search2Icon colour='#666' height='28px' width='28px'/>}
                        style={{marginBottom: '0'}}
                        value={query}
                    />
                </form>

                <BTDSelectField
                    label='Filter by letter'
                    onChange={(value) => {
                        setLetter(value);
                        searchByLetter({query: value})}}
                    options={[
                        {id: 'a', name: 'A'},
                        {id: 'b', name: 'B'},
                        {id: 'c', name: 'C'},
                        {id: 'd', name: 'D'},
                        {id: 'e', name: 'E'},
                        {id: 'f', name: 'F'},
                        {id: 'g', name: 'G'},
                        {id: 'h', name: 'H'},
                        {id: 'i', name: 'I'},
                        {id: 'j', name: 'J'},
                        {id: 'k', name: 'K'},
                        {id: 'l', name: 'L'},
                        {id: 'm', name: 'M'},
                        {id: 'n', name: 'N'},
                        {id: 'o', name: 'O'},
                        {id: 'p', name: 'P'},
                        {id: 'q', name: 'Q'},
                        {id: 'r', name: 'R'},
                        {id: 's', name: 'S'},
                        {id: 't', name: 'T'},
                        {id: 'u', name: 'U'},
                        {id: 'v', name: 'V'},
                        {id: 'w', name: 'W'},
                        {id: 'x', name: 'X'},
                        {id: 'y', name: 'Y'},
                        {id: 'z', name: 'Z'}
                    ]}
                    startIcon={<LetterIcon colour='#666' height='28px' width='28px'/>}
                    style={{gridArea: 'letter', margin: '0'}}
                    value={letter}
                />


                <div className='StockListScreen__filters__menuWrapper'>
                    <BTDMenu icon={<EllipsisIcon colour='#A0A0A0' height="20px" style={{gridArea: 'menu', padding: '20px', transform: 'rotate(90deg)'}} />} style={{alignItems: 'center', display: 'flex', height: '60px'}} >
                        <li onClick={() => {generatePDF()}}>Download Stock PDF</li>
                        <li onClick={() => {generateCSV()}}>Export stock as CSV</li>
                    </BTDMenu>
                    <a id="downloadLink" href=""/>
                </div>

            </div>

            {showPagination && meta && meta.length !== 0 &&
                <p className='StockListScreen__text opacity'>Displaying {meta.from.toLocaleString()} to {meta.to.toLocaleString()} of {meta.total.toLocaleString()} stock</p>
            }

            { (searchLoading || searchbyLetterLoading) && ! isLoading ? 
                <>
                <div style={{ 
                    alignItems: 'center',
                    display: 'flex',
                    height: '40vh',
                    justifyContent: 'center',
                    width: '100%', 
                    }}
                >
                    <BTDProgress height={50} type='circular' width={50} />
                </div>
            </>
            :
                <StockList 
                    isLoading={isLoading}  
                    items={stock} 
                    onChange={() => {onChange()}}
                    query={query ?? ''}
                />
                }

            {showPagination && meta && meta.total > meta.per_page &&
                <BTDPagination
                    currentPage={meta.current_page} 
                    totalPages={meta.last_page}
                    onChange={(value) => {
                        setPage(value);
                        onChange();
                    }}
                    style={{margin: '30px auto', width: 'max-content'}}
                />
            }	

            <AddIcon colour='#40506B' onClick={() => {
                setFormActive(true);
            }} />

            {formActive &&
                <StockCreateScreen
                    onClose={() => {
                        setFormActive(false);
                    }} 
                    onSubmit={() => {
                        onChange();
                        setFormActive(false);
                    }} 
                />
            }

        </StockLayout>
    )

}

export default StockScreen;